export interface ValidationResult {
  isValid: boolean;
  errors: Record<string, string>;
}

export function validateRequired(
  value: string | undefined,
  fieldName: string,
): string | null {
  if (!value || value.trim() === "") {
    return `${fieldName} is required`;
  }
  return null;
}

export function combineValidators<T extends Record<string, any>>(
  values: T,
  validators: { [K in keyof T]?: (value: T[K]) => string | null },
): ValidationResult {
  const errors: Record<string, string> = {};
  let isValid = true;

  for (const [field, validator] of Object.entries(validators)) {
    if (validator) {
      const error = validator(values[field]);
      if (error) {
        errors[field] = error;
        isValid = false;
      }
    }
  }

  return { isValid, errors };
}
